export default __webpack_public_path__ + "static/media/bt_logo_horizontal.0af2926a.png";